export default "__VITE_ASSET__e1gHI2$o__"